module.exports = __webpack_public_path__ + "img/bch.c09d291a.svg";